import { QueryClient } from "@tanstack/react-query";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

const staleTime = {
  Infinity,
  oneMinute: 60_000,
  oneDay: 24 * 60 * 60 * 1000,
};

export { queryClient, staleTime };
